import EventEmitter from "../classes/EventEmitter"

/**
 * Получить объект для работы с событиями
 */
export default new EventEmitter()